import { ElementsIconProps } from '../UI';

export const AccountsIllustration = ({ fillColor, className }: ElementsIconProps) => {
  return (
    <svg width="350" height="314" viewBox="0 0 350 314" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <ellipse cx="245.664" cy="189.171" rx="35.749" ry="35.647" fill="url(#paint0_linear_2181_12383)" />
      <ellipse cx="245.664" cy="189.171" rx="34.0467" ry="33.9495" fill="#F5F5F5" />
      <g opacity="0.5">
        <path
          d="M246.617 167.962C235.471 167.588 225.924 175.855 224.735 186.913H218.607C217.923 186.913 217.368 187.466 217.368 188.149V190.186C217.368 190.869 217.922 191.423 218.607 191.425H224.735C225.944 202.693 235.819 211.025 247.163 210.349C258.508 209.673 267.317 200.227 267.171 188.896C267.025 177.564 257.975 168.347 246.617 167.962Z"
          fill={fillColor || 'currentColor'}
        />
      </g>
      <path
        d="M246.341 169.235C235.863 168.881 226.888 176.654 225.774 187.049H219.843C219.296 187.049 218.852 187.491 218.852 188.037V190.301C218.851 190.564 218.955 190.816 219.141 191.002C219.327 191.188 219.58 191.292 219.843 191.292H225.774C226.916 201.882 236.201 209.708 246.863 209.068C257.525 208.428 265.802 199.548 265.662 188.899C265.523 178.249 257.016 169.587 246.341 169.225V169.235Z"
        fill="white"
      />
      <ellipse cx="245.664" cy="189.171" rx="14.0443" ry="14.0042" fill={fillColor} />
      <path
        opacity="0.2"
        d="M252.899 182.381C252.899 182.381 256.906 188.587 255.759 193.414C255.759 193.414 260.338 185.826 252.899 182.381Z"
        fill="white"
      />
      <ellipse opacity="0.2" cx="254.601" cy="196.809" rx="1.27676" ry="1.2731" fill={fillColor} />
      <path
        d="M0.336884 75.4546L71.1578 59.4752L94.3551 161.7L23.5342 177.679L0.336884 75.4546Z"
        fill="url(#paint1_linear_2181_12383)"
      />
      <path
        d="M73.6391 58.9169L144.46 42.9375L167.657 145.162L96.8364 161.142L73.6391 58.9169Z"
        fill="url(#paint2_linear_2181_12383)"
      />
      <path d="M1.60951 76.4646L70.6705 60.8823L93.3636 160.885L24.3026 176.467L1.60951 76.4646Z" fill={fillColor} />
      <path d="M74.4393 60.0311L143.5 44.4488L166.193 144.452L97.1324 160.034L74.4393 60.0311Z" fill="#F5F5F5" />
      <path d="M16.3891 84.5095L57.8582 75.1528L59.4219 82.0434L17.9528 91.4002L16.3891 84.5095Z" fill="#F5F5F5" />
      <path d="M13.2572 102.726L68.5472 90.251L68.9379 91.9729L13.6479 104.448L13.2572 102.726Z" fill="#F5F5F5" />
      <path d="M14.1686 106.745L69.4586 94.2695L69.8493 95.9913L14.5593 108.466L14.1686 106.745Z" fill="#F5F5F5" />
      <path d="M15.0835 110.763L70.3734 98.288L70.7641 100.01L15.4742 112.485L15.0835 110.763Z" fill="#F5F5F5" />
      <path d="M15.9934 114.784L42.4861 108.807L42.8768 110.528L16.3841 116.506L15.9934 114.784Z" fill="#F5F5F5" />
      <path d="M16.9083 118.808L47.4323 111.921L47.823 113.643L17.299 120.53L16.9083 118.808Z" fill="#F5F5F5" />
      <path d="M17.8185 122.829L73.1084 110.353L73.4991 112.075L18.2092 124.55L17.8185 122.829Z" fill="#F5F5F5" />
      <path d="M18.7333 126.847L74.0232 114.372L74.414 116.094L19.124 128.569L18.7333 126.847Z" fill="#F5F5F5" />
      <path d="M19.6454 130.867L70.904 119.301L71.2947 121.023L20.0361 132.589L19.6454 130.867Z" fill="#F5F5F5" />
      <path d="M20.5561 134.887L75.8461 122.412L76.2368 124.134L20.9469 136.609L20.5561 134.887Z" fill="#F5F5F5" />
      <path d="M21.4676 138.908L50.2649 132.41L50.6556 134.132L21.8583 140.63L21.4676 138.908Z" fill="#F5F5F5" />
      <path
        opacity="0.3"
        d="M97.3848 126.609L127.909 119.722L128.3 121.443L97.7756 128.331L97.3848 126.609Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M98.295 130.629L153.585 118.154L153.976 119.876L98.6857 132.351L98.295 130.629Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M99.2098 134.648L154.5 122.173L154.891 123.894L99.6006 136.37L99.2098 134.648Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M100.122 138.667L151.381 127.102L151.771 128.824L100.513 140.389L100.122 138.667Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M101.033 142.688L156.323 130.213L156.713 131.935L101.423 144.41L101.033 142.688Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M101.944 146.709L130.741 140.211L131.132 141.933L102.335 148.431L101.944 146.709Z"
        fill={fillColor}
      />
      <path d="M43.7646 141.121L77.1677 133.584L82.381 156.557L48.9778 164.094L43.7646 141.121Z" fill="#F5F5F5" />
      <path
        opacity="0.3"
        d="M83.3099 64.5808L116.713 57.0441L121.926 80.0174L88.5231 87.5542L83.3099 64.5808Z"
        fill={fillColor}
      />
      <path
        opacity="0.3"
        d="M116.003 88.5974L149.406 81.0607L154.619 104.034L121.216 111.571L116.003 88.5974Z"
        fill={fillColor}
      />
      <path
        d="M100.439 86.2797C99.9832 84.2719 101.243 82.2759 103.251 81.8228L166.802 67.4836C168.809 67.0309 170.803 68.2894 171.259 70.2952L192.807 165.252C193.262 167.26 192.003 169.256 189.995 169.709L126.443 184.048C124.437 184.501 122.442 183.243 121.987 181.237L100.439 86.2797Z"
        fill="url(#paint3_linear_2181_12383)"
      />
      <path
        d="M101.242 87.3939C100.787 85.386 102.046 83.3901 104.055 82.937L165.846 68.9949C167.852 68.5422 169.847 69.8006 170.302 71.8065L191.346 164.542C191.802 166.55 190.542 168.546 188.534 168.999L126.742 182.941C124.736 183.394 122.742 182.135 122.286 180.129L101.242 87.3939Z"
        fill={fillColor}
      />
      <g opacity="0.5">
        <rect x="75.3624" y="226.973" width="1.0214" height="5.77142" fill={fillColor} />
        <path d="M78.767 229.35V230.368H72.9791V229.35H78.767Z" fill={fillColor} />
      </g>
      <g opacity="0.5">
        <rect x="247.707" y="54.0515" width="1.02139" height="5.77142" fill={fillColor} />
        <path d="M251.111 56.428V57.4465H245.323V56.428H251.111Z" fill={fillColor} />
      </g>
      <g opacity="0.5">
        <rect x="217.065" y="127.722" width="1.02141" height="5.77142" fill={fillColor} />
        <path d="M220.469 130.098V131.117H214.681V130.098H220.469Z" fill={fillColor} />
      </g>
      <g opacity="0.5">
        <rect x="304.769" y="140.962" width="1.02139" height="5.77142" fill={fillColor} />
        <path d="M308.17 143.342V144.361H302.382V143.342H308.17Z" fill={fillColor} />
      </g>
      <path
        opacity="0.5"
        d="M134.839 226.396C134.256 226.143 133.956 225.495 134.141 224.889C134.158 224.844 134.167 224.797 134.168 224.75C134.186 224.474 134.019 224.219 133.759 224.123C133.499 224.028 133.207 224.114 133.041 224.335C133.015 224.374 132.992 224.415 132.973 224.458C132.714 225.033 132.065 225.324 131.461 225.137C131.416 225.122 131.369 225.113 131.321 225.11C131.045 225.092 130.789 225.257 130.693 225.517C130.597 225.776 130.684 226.068 130.906 226.233C130.944 226.261 130.985 226.285 131.029 226.305C131.612 226.557 131.913 227.206 131.727 227.812C131.713 227.856 131.704 227.902 131.699 227.948C131.68 228.224 131.845 228.481 132.106 228.577C132.367 228.674 132.66 228.587 132.826 228.365C132.854 228.326 132.876 228.284 132.894 228.24C133.155 227.664 133.805 227.373 134.41 227.561C134.454 227.575 134.499 227.584 134.546 227.588C134.822 227.606 135.078 227.44 135.174 227.18C135.27 226.921 135.183 226.63 134.961 226.464C134.923 226.436 134.882 226.414 134.839 226.396Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M184.615 268.714C184.039 268.455 183.747 267.809 183.934 267.207C183.948 267.162 183.957 267.115 183.961 267.068C183.979 266.792 183.813 266.537 183.553 266.441C183.292 266.346 183 266.432 182.834 266.653C182.807 266.692 182.784 266.733 182.766 266.776C182.514 267.359 181.863 267.659 181.254 267.472C181.209 267.458 181.162 267.449 181.115 267.444C180.838 267.427 180.583 267.592 180.487 267.852C180.391 268.111 180.477 268.403 180.699 268.568C180.737 268.597 180.778 268.621 180.822 268.64C181.398 268.899 181.689 269.545 181.503 270.147C181.489 270.192 181.479 270.239 181.476 270.286C181.458 270.562 181.624 270.817 181.884 270.912C182.144 271.008 182.437 270.922 182.603 270.7C182.631 270.661 182.653 270.619 182.671 270.575C182.93 270 183.579 269.708 184.182 269.896C184.228 269.91 184.275 269.919 184.322 269.923C184.599 269.941 184.854 269.775 184.95 269.515C185.046 269.256 184.959 268.965 184.737 268.799C184.701 268.765 184.659 268.737 184.615 268.714Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M259.177 122.392C258.601 122.132 258.31 121.486 258.496 120.885C258.51 120.839 258.52 120.793 258.523 120.745C258.541 120.469 258.375 120.215 258.115 120.119C257.855 120.023 257.562 120.11 257.396 120.331C257.369 120.369 257.346 120.41 257.328 120.453C257.077 121.036 256.425 121.336 255.817 121.149C255.771 121.135 255.724 121.126 255.677 121.122C255.4 121.104 255.145 121.27 255.049 121.53C254.953 121.789 255.04 122.08 255.262 122.246C255.299 122.275 255.34 122.299 255.384 122.317C255.96 122.577 256.252 123.223 256.065 123.825C256.051 123.87 256.042 123.916 256.038 123.964C256.02 124.24 256.186 124.494 256.446 124.59C256.707 124.686 256.999 124.599 257.165 124.378C257.193 124.339 257.216 124.297 257.233 124.252C257.492 123.677 258.141 123.386 258.745 123.573C258.79 123.587 258.837 123.596 258.884 123.6C259.161 123.618 259.416 123.453 259.512 123.193C259.608 122.934 259.522 122.642 259.3 122.477C259.263 122.443 259.222 122.415 259.177 122.392Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M310.928 177.051C310.352 176.791 310.061 176.145 310.247 175.543C310.261 175.498 310.271 175.451 310.274 175.404C310.292 175.128 310.126 174.873 309.866 174.778C309.606 174.682 309.313 174.768 309.147 174.99C309.12 175.028 309.097 175.069 309.079 175.112C308.828 175.695 308.176 175.995 307.568 175.808C307.522 175.794 307.475 175.785 307.428 175.781C307.151 175.763 306.896 175.929 306.8 176.188C306.704 176.448 306.791 176.739 307.013 176.905C307.05 176.934 307.091 176.957 307.135 176.976C307.711 177.235 308.003 177.881 307.816 178.483C307.802 178.528 307.793 178.575 307.789 178.622C307.771 178.898 307.937 179.153 308.197 179.249C308.458 179.344 308.75 179.258 308.916 179.037C308.944 178.998 308.967 178.956 308.984 178.911C309.243 178.336 309.892 178.044 310.496 178.232C310.541 178.246 310.588 178.255 310.635 178.259C310.912 178.277 311.167 178.111 311.263 177.852C311.359 177.592 311.273 177.301 311.051 177.135C311.014 177.102 310.973 177.073 310.928 177.051Z"
        fill="#4D8AF0"
      />
      <ellipse opacity="0.5" cx="48.8059" cy="208.301" rx="2.0428" ry="2.03697" fill={fillColor} />
      <ellipse opacity="0.5" cx="178.592" cy="60.1625" rx="2.0428" ry="2.03697" fill={fillColor} />
      <ellipse opacity="0.5" cx="170.08" cy="209.201" rx="2.0428" ry="2.03696" fill={fillColor} />
      <ellipse opacity="0.5" cx="287.882" cy="260.125" rx="2.0428" ry="2.03697" fill="#F55F44" />
      <g opacity="0.5">
        <path
          d="M267.273 139.756L295.108 46.7119C295.446 45.5818 296.639 44.9389 297.772 45.276L347.664 60.1164C348.797 60.4535 349.442 61.643 349.104 62.7731L321.269 155.817C320.932 156.946 319.741 157.587 318.609 157.251L268.711 142.408C267.581 142.07 266.938 140.884 267.273 139.756Z"
          fill="url(#paint4_linear_2181_12383)"
        />
      </g>
      <path
        d="M295.022 49.7617C295.62 47.7621 297.725 46.6242 299.726 47.2193L345.011 60.6894C347.014 61.2852 348.153 63.3925 347.554 65.3946L321.435 152.702C320.837 154.702 318.732 155.84 316.731 155.245L271.446 141.775C269.443 141.179 268.304 139.072 268.903 137.07L295.022 49.7617Z"
        fill="white"
      />
      <path
        d="M334.849 60.2745C333.926 62.2633 331.679 63.2752 329.572 62.6509L311.429 57.2496C309.322 56.6183 307.996 54.5452 308.31 52.3744L298.709 49.5193C297.607 49.194 296.449 49.8177 296.118 50.9146L270.423 136.749C270.265 137.277 270.325 137.845 270.588 138.329C270.851 138.813 271.296 139.173 271.825 139.329L317.734 152.991C318.835 153.318 319.993 152.693 320.322 151.595L346.006 65.7607C346.165 65.2335 346.106 64.6651 345.844 64.181C345.581 63.6969 345.136 63.3369 344.607 63.1806L334.849 60.2745Z"
        fill="#E0E0E0"
      />
      <path
        d="M314.879 55.9619C314.926 55.7971 315.098 55.7015 315.263 55.7483L326.415 58.9138C326.58 58.9607 326.675 59.1325 326.628 59.2975L326.59 59.4318C326.543 59.5966 326.371 59.6922 326.206 59.6454L315.055 56.4799C314.89 56.433 314.794 56.2612 314.841 56.0962L314.879 55.9619Z"
        fill="#DBDBDB"
      />
      <ellipse cx="329.123" cy="60.0131" rx="0.459625" ry="0.458319" fill="#DBDBDB" />
      <path d="M297.087 66.4956L311.53 70.4624L308.094 82.9L293.651 78.9332L297.087 66.4956Z" fill="white" />
      <path
        opacity="0.3"
        d="M292.11 84.4977L306.553 88.4645L303.117 100.902L288.675 96.9353L292.11 84.4977Z"
        fill={fillColor}
      />
      <path d="M287.141 102.497L301.584 106.464L298.148 118.902L283.705 114.935L287.141 102.497Z" fill="white" />
      <path
        opacity="0.3"
        d="M282.164 120.5L296.607 124.466L293.171 136.904L278.728 132.937L282.164 120.5Z"
        fill="#3AD29F"
      />
      <path d="M314.325 74.3972L333.363 79.6261L333.002 80.9354L313.964 75.7064L314.325 74.3972Z" fill="white" />
      <path d="M313.24 78.3243L332.278 83.5532L331.916 84.8625L312.878 79.6335L313.24 78.3243Z" fill="white" />
      <path d="M309.442 92.0755L328.48 97.3045L328.119 98.6137L309.08 93.3847L309.442 92.0755Z" fill="white" />
      <path d="M308.358 95.9993L327.396 101.228L327.034 102.538L307.996 97.3085L308.358 95.9993Z" fill="white" />
      <path d="M304.56 109.751L323.598 114.98L323.236 116.289L304.198 111.06L304.56 109.751Z" fill="white" />
      <path d="M303.474 113.678L322.512 118.907L322.151 120.216L303.113 114.987L303.474 113.678Z" fill="white" />
      <path d="M299.677 127.422L318.716 132.651L318.354 133.96L299.316 128.731L299.677 127.422Z" fill="white" />
      <path d="M298.592 131.353L317.63 136.582L317.269 137.891L298.23 132.662L298.592 131.353Z" fill="white" />
      <defs>
        <linearGradient
          id="paint0_linear_2181_12383"
          x1="281.413"
          y1="224.818"
          x2="281.413"
          y2="153.524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2181_12383"
          x1="94.3553"
          y1="161.703"
          x2="71.2417"
          y2="59.4302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2181_12383"
          x1="167.657"
          y1="145.162"
          x2="144.543"
          y2="42.8892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2181_12383"
          x1="193.637"
          y1="168.889"
          x2="170.522"
          y2="66.6131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2181_12383"
          x1="288.293"
          y1="191.927"
          x2="380.554"
          y2="159.388"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};
